import { createMmWsAction } from '@skynet/data-ws-mm';

type JsonSerializedArray = string;

export interface ListenPayload {
  section: 'arbitrage';
  arbitragesID?: JsonSerializedArray;
}

export const listen = createMmWsAction<ListenPayload, ListenPayload>(
  'arbitrage/listen',
  (data) => ({
    command: 'Listen',
    ...data,
  }),
);
